import React from 'react';

export default function Block4_5Targets() {
  return (
    <section className="py-16 md:py-24 bg-[#efefff] text-ink px-4 md:px-16" id="metas">
      <div className="max-w-[900px] mx-auto overflow-hidden w-full flex flex-col items-start">
        <div className="mb-16 md:mb-10 max-w-2xl px-2">
          <div className="text-[14px] font-semibold text-ink-soft/70 mb-4">
            Metas sanitarias
          </div>
          <h2 className="text-[28px] md:text-[36px] lg:text-[40px] font-bold text-ink leading-[1.2] tracking-tight mb-6">
            Las metas sanitarias se alcanzan persona a persona.
          </h2>
          <p className="text-[16px] md:text-[18px] text-ink-soft leading-[1.6]">
            El indicador deja de ser solamente un porcentaje retrospectivo y se convierte en una cartera nominal de acciones ejecutables.
          </p>
        </div>
        <div className="w-full flex justify-start px-2">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-x-12 gap-y-6 w-full max-w-4xl opacity-90 mb-16">
            {[
              { id: '1142', act: 'Coordinar toma' },
              { id: '0284', act: 'Preparar ingreso' },
              { id: '3091', act: 'Contactar preventivo' },
              { id: '4011', act: 'Rescatar inasistencia' },
              { id: '1992', act: 'Agendar control' },
              { id: '5501', act: 'Coordinar examen' },
              { id: '8210', act: 'Confirmar asistencia' },
              { id: '9923', act: 'Preparar visita' },
            ].map((p, i) => (
              <div key={i} className="flex flex-col gap-1 border-l-2 border-brand/30 pl-4">
                <span className="font-mono text-[14px] text-ink-soft/70">ID: {p.id}</span>
                <span className="text-[16px] text-ink font-medium">{p.act}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
